import { httpClient } from "../http/httpClient";

export type OfertaPreAprovada = {
  idOferta: string;
  descricaoProduto: string;
  valorSimulacao: number;
  quantidadeParcelas: number;
  valorParcela: number;
  dataAtivacaoBeneficio: string;
  mensagemDataAtivacaoBeneficio: string;
  validadeOferta: string;
  codigoInterno: number;
  codigoSimulacao: string;
};

export type MaxValue = {
  convenioId: number;
  nomeConvenio: string;
  tipoSimulacaoId: number;
  tipoSimulacao: string;
  prazoMaximo: number;
  valorParcelaMaximo: string;
  valorTomadorMaximo: string;
  tipoCliente: string;
};

export type GetOperationsResponse = {
  mensagem: string;
  status: boolean;
  clienteId: string;
  permiteCaptura: boolean;
  permiteCapturaMensagem: string;
  permiteCapturaRefin: boolean;
  permiteCapturaRefinMensagem: string;
  ofertasPreAprovadas?: OfertaPreAprovada[];
  refinRecorrente: {
    possuiAdesao: boolean;
    permiteFazerAdesao: boolean;
  };
  maxValues: MaxValue[];
};

export async function getOperations(cpf: string) {
  const response = await httpClient
    .get<GetOperationsResponse>(`/crefisa/operations/${cpf}`)
    .catch((error) => {
      throw error.response?.data || error;
    });
  return response.data;
}
